// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#all-email-logs .listings__table .el-table table tbody tr td.el-table__cell {\n  padding: 2.7px;\n}", ""]);
// Exports
module.exports = exports;
